<template lang="pug">
  .dashboard-invoices
    v-row.mx-3(no-gutters)
      .s1 {{ $t('unpaid_invoices') }}
      v-spacer
      .c1.primary400--text.my-auto {{ $t('this_year') }}
    v-card.mx-3.pa-4.mt-2(flat outlined style="border: 1px solid var(--v-primary200);")
      v-row(no-gutters)
        v-col.px-2(@click="$router.push('/admin/yezza-book/incomes')")
          v-row.my-1.clickable(no-gutters)
            .s2.primary400--text.my-auto {{ $t('income') }}
            div.my-auto(style="width:20px; height:20px;")
              eva-icon(name="chevron-right-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].primary400")
          .h6.mb-1 {{ incomesSummary.total | displayPrice }}
          .p2.mb-1.danger500--text {{ $t('overdue') }}: {{ incomesSummary.total_overdue | displayPrice }}
        v-divider.basic300(vertical)
        v-col.pl-6(@click="$router.push('/admin/yezza-book/expenses')")
          v-row.my-1.clickable(no-gutters)
            .s2.primary400--text.my-auto {{ $t('expense') }}
            div.my-auto(style="width:20px; height:20px;")
              eva-icon(name="chevron-right-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].primary400")
          .h6.mb-1 {{ expenseSummary.total | displayPrice }}
          .p2.mb-1.danger500--text {{ $t('overdue') }}: {{ expenseSummary.total_overdue | displayPrice }}

</template>

<script>

export default {
  name: 'DashboardUnpaidInvoices',
  props: ['company', 'update'],
  data: () => ({
    incomesSummary: {
      total: 0,
      total_overdue: 0
    },
    expenseSummary: {
      total: 0,
      total_overdue: 0
    }
  }),
  mounted () {
    this.fetchSummary()
  },
  watch: {
    update () {
      this.fetchSummary()
    }
  },
  methods: {
    fetchSummary () {
      this.$axios.get(`/books/${this.company.slug}/incomes/summary?span=year`)
        .then((response) => {
          this.incomesSummary = response.data
        }).catch(() => {})
      this.$axios.get(`/books/${this.company.slug}/expenses/summary?span=year`)
        .then((response) => {
          this.expenseSummary = response.data
        }).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
